module.exports = __webpack_public_path__ + "assets/img/hosp-subscribe-success-icon.7b767c60.png";